<template>
  <div class="vip" v-buried :data-buried="BuriedData.BG_KAITONG_VIP">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :zIndex="999"
      :title="title"
    >
      <div slot="right">
        <span class="explain iconfont icon-help" @click="bindExplain"></span>
      </div>
    </AppNavbar>
    <div class="user-info" v-if="userInfo">
      <div class="u-top">
        <div class="u-top-title">
          <div class="vip-type" v-if="vipInfo"
            >减脂{{ vipTypeOptions[vipInfo.type_id] }}卡会员</div
          >
          <div class="end-time"
            >到期<span class="time">{{
              vipInfo.end_time | filterEndTime
            }}</span></div
          >
        </div>
        <div class="info">
          <img class="avatar" :src="userInfo.head_img" alt="" />
          <div class="info-r">
            <div class="nickname">{{ userInfo.truename }}</div>
            <div class="desc"
              >您已经成为WE+减脂会员{{ vipInfo.use_time }}天了</div
            >
          </div>
        </div>
      </div>
      <div class="u-bottom" @click="bindCoachReply">
        <img
          class="iconfont"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a8bc73f4bfbc9656cc1288d5d7d08a93.png"
        /><span class="text1">有问题请联系您的私人陪伴官</span>
        <span class="text2">工作日 09:00-18:00</span>
      </div>
    </div>
    <!-- 我的权益 -->
    <div class="my-right" v-if="userInfo">
      <div class="icon-container">
        <div class="icon-scroll" @scroll="bindNavScroll">
          <div class="icon-list">
            <div
              class="icon-item"
              v-for="(item, index) in myShowRightList"
              :key="index"
              @click="bindRightMenu(item.id)"
            >
              <img class="icon-image" :src="item.icon" alt="" />
              <div class="icon-text">{{ item.iconName }}</div>
            </div>
          </div>
        </div>
        <div class="icon-line" v-if="myShowRightList.length > 5">
          <div class="line" :style="{ left: curLineLeft + 'px' }"></div>
        </div>
      </div>
      <!-- 月卡资源位 -->
      <van-swipe
        class="banner-swipe"
        :autoplay="5000"
        v-if="bannerList.length"
        :show-indicators="false"
      >
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img
            class="banner-image"
            :src="item.img"
            alt=""
            :data-buried="BuriedData.BG_VIP_MONTH_BANNER"
            v-clickBuried
            v-buried
            :data-click-buried="BuriedData.CLICK_VIP_MONTH_BANNER"
            @click="bindClickBanner(item)"
          />
        </van-swipe-item>
      </van-swipe>
      <!-- 我的权益列表 -->
      <div class="right-list">
        <div
          class="right-ul"
          v-for="(ulItem, ulIndex) in myShowRight"
          :key="ulIndex"
        >
          <div class="top-title-position">
            <img
              class="top-title"
              v-if="ulItem.title"
              :src="ulItem.title"
              alt=""
            />
          </div>
          <div class="right-li">
            <div
              class="right-item"
              v-for="(item, index) in ulItem.list"
              :key="index"
              :id="'right-' + item.id"
            >
              <div class="r-i-top" v-if="item.title">
                <img
                  class="r-i-flag"
                  v-if="item.important"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dec66a810243f5c37b7f640a60143232.png"
                  alt=""
                />
                <div class="r-i-title">{{ item.title }}</div>
                <div class="use-status"
                  ><span class="use" v-if="item.use !== undefined"
                    >已用{{ item.use }}次</span
                  ><span class="can-use" v-if="item.canUse !== undefined">
                    剩{{ item.canUse - item.use }}次</span
                  ></div
                >
              </div>
              <div class="r-i-bottom">
                <VipComponentOne
                  v-if="item.id == 1"
                  :data="item.data"
                ></VipComponentOne>
                <VipComponentTwo
                  v-if="item.id == 2"
                  :data="item.data"
                  @click="bindShowToast"
                >
                </VipComponentTwo>
                <!-- 营养师在线答疑 -->
                <div class="answer-content" v-if="item.id == 3">
                  <div class="a-title">
                    <div class="title">营养师团队为您答疑</div>
                    <div class="tip">小班制</div>
                  </div>
                  <div class="desc1">请添加您的私人陪伴官 </div>
                  <div
                    class="btn"
                    @click="bindCoachReply"
                    v-buried
                    :data-buried="BuriedData.BG_VIP_DAYI_LIJITIANJIA"
                    v-clickBuried
                    :data-click-buried="BuriedData.CLICK_VIP_DAYI_LIJITIANJIA"
                    >立即添加<span class="iconfont icon-you"></span>
                  </div>
                </div>
                <!-- 营养课 -->
                <div v-if="item.id == 9">
                  <div class="r-i-top">
                    <div class="r-i-title">营养课专栏</div>
                    <div class="r-receive" @click="bindReceiveCourse(0)"
                      >点击领取</div
                    >
                    <div class="r-space"></div>
                    <div
                      class="all"
                      @click="bindClickAllCourse"
                      :data-buried="BuriedData.BG_VIP_CLASS_List[0]"
                      v-clickBuried
                      v-buried
                      :data-click-buried="BuriedData.CLICK_VIP_CLASS_List[0]"
                      ><span>查看全部</span
                      ><span class="iconfont icon-you"></span
                    ></div>
                  </div>
                  <div class="tool-scroll" style="margin-bottom: 20px">
                    <!-- 营养课专栏 -->
                    <div class="tool-list">
                      <div
                        class="course-item"
                        :style="{ background: item1.bgColor }"
                        v-buried
                        :data-buried="BuriedData.BG_VIP_CLASS_List[item1.id]"
                        v-clickBuried
                        :data-click-buried="
                          BuriedData.CLICK_VIP_CLASS_List[item1.id]
                        "
                        v-for="(item1, index1) in courseList"
                        :key="index1"
                        @click="bindClickCourse(item1)"
                      >
                        <img class="course-image" :src="item1.image" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="r-i-top">
                    <div class="r-i-title">运动课专栏</div>
                    <div class="r-receive" @click="bindReceiveCourse(1)"
                      >点击领取</div
                    >
                    <div class="r-space"></div>
                    <div
                      class="all"
                      @click="bindClickAllSport"
                      :data-buried="BuriedData.BG_VIP_SPORT_List[0]"
                      v-clickBuried
                      v-buried
                      :data-click-buried="BuriedData.CLICK_VIP_SPORT_List[0]"
                      ><span>查看全部</span
                      ><span class="iconfont icon-you"></span
                    ></div>
                  </div>
                  <div class="tool-scroll">
                    <!-- 运动课专栏 -->
                    <div class="tool-list">
                      <div
                        class="course-item"
                        :style="{ background: item1.bgColor }"
                        v-buried
                        :data-buried="BuriedData.BG_VIP_SPORT_List[item1.id]"
                        v-clickBuried
                        :data-click-buried="
                          BuriedData.CLICK_VIP_SPORT_List[item1.id]
                        "
                        v-for="(item1, index1) in sportList"
                        :key="index1"
                        @click="bindClickCourse(item1)"
                      >
                        <img class="course-image" :src="item1.image" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="course-tips"
                    >*新增课程权益，未开通请联系客服领取</div
                  >
                </div>
                <!-- 减脂工具-专家版 -->
                <div v-if="item.id == 4" class="tool-scroll">
                  <div class="tool-list">
                    <div
                      class="tool-item"
                      :style="{ background: item1.bgColor }"
                      v-for="(item1, index1) in menuList"
                      :key="index1"
                      @click="bindClickMenu(item1)"
                    >
                      <div class="i-top">
                        <div class="i-title">{{ item1.title }}</div>
                        <div class="iconfont icon-you"></div>
                      </div>
                      <div class="i-desc" v-html="item1.desc"></div>
                      <div class="count">{{ item1.count }}</div>
                      <img :src="item1.image" class="i-image" alt="" />
                    </div>
                  </div>
                </div>
                <!-- betterWE明星减脂营100元抵扣券 -->
                <div
                  class="coupon camp-coupon"
                  v-if="item.id == 5"
                  @click="bindToCoupon"
                >
                  <div class="coupon-name"
                    ><span class="coupon-num">{{ item.count }}</span
                    ><span>元无门槛抵扣券</span>
                  </div>
                  <div class="range">使用范围: 任意明星同款减脂营</div>
                  <div
                    class="btn"
                    :class="{ 'disabled-btn': !item.data || !item.data.length }"
                    ><span>{{
                      item.data && item.data.length ? '已到账' : '未到账'
                    }}</span
                    ><span class="iconfont icon-you"></span
                  ></div>
                </div>
                <!-- 专属礼券包 -->
                <VipComponentThree
                  v-if="item.id == 6"
                  :data="item.data"
                ></VipComponentThree>
                <!-- 营养师严选商城 全场95折 -->
                <div class="coupon shop-coupon" v-if="item.id == 7">
                  <div class="c-title">抢先囤好货，商城全场95折</div>
                  <div class="c-desc">与活动优惠券可叠加</div>
                  <div class="btn" @click="bindShop"
                    ><span>立即选购</span
                    ><span class="iconfont icon-you"></span>
                  </div>
                </div>
                <!-- 线下健盟私教体验课 免费送 -->
                <div
                  class="coupon gym-coupon"
                  v-if="item.id == 8"
                  @click="bindCourse"
                >
                  <div class="c-title">健萌专属私教课体验卡</div>
                  <div class="c-desc">请添加您的私人陪伴官 领取私教卡 </div>
                  <div class="tip"
                    >·仅限长沙/南京/苏州地区 ·仅限健萌新用户
                  </div>
                  <div class="btn"
                    ><span>立即领取</span><span class="iconfont icon-you"></span
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReserveToast
      v-if="showToast"
      @close="bindClose"
      :sDate="toastData.appointment_s_date"
      :eDate="toastData.appointment_e_date"
      @consult="bindCoachReply"
    ></ReserveToast>
  </div>
</template>
<script>
import { deepClone } from '@/common/common.js'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import VipComponentOne from './component-one.vue'
import VipComponentTwo from './component-two.vue'
import VipComponentThree from './component-three.vue'
import ReserveToast from './reserve-toast.vue'
import {
  getRightList,
  vipTypeOptions,
  bindConsultCoach,
  bindConsultGym,
  courseList,
  sportList,
  BuriedData
} from './data'
export default {
  components: {
    AppNavbar,
    VipComponentOne,
    VipComponentTwo,
    VipComponentThree,
    ReserveToast
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    vipInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  filters: {
    filterEndTime(time) {
      return time.slice(0, 10).replace(/-/g, '.')
    }
  },
  data() {
    return {
      BuriedData,
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(0,0,0.8)'
      },
      title: 'WE+减脂会员',
      myRight: [],
      courseList: courseList.filter((item) => {
        return !item.hide
      }), //营养课列表
      sportList: sportList.filter((item) => {
        return !item.hide
      }), //运动课列表
      vipTypeOptions, //vip类型
      curLineLeft: 0,
      showToast: false,
      toastData: {},
      bannerList: [], //资源位
      menuList: [
        {
          name: 'todayDietResult',
          title: '今天吃什么',
          desc: '不知道吃什么？<br/>来抽海量严选减脂菜！',
          router: '/eating-today/index',
          count: '无限次数',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b2c399e0c3d4d1e0fed8b0fb202ce4af.png',
          bgColor: 'linear-gradient(134deg, #FFF5F9 0%, #FFE8F6 100%)'
        },
        {
          name: 'ingredientResult',
          title: '配料表解读',
          router: '/ingredient/index',
          desc: '这个能吃吗?<br/>一拍就知道',
          count: '无限次数',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e48b416fc4e2d584b3db31779323b991.png',
          bgColor: 'linear-gradient(134deg, #EFF0FD 0%, #DADBF7 100%)'
        },
        {
          name: 'dietCalculate',
          title: '饮食计算器',
          router: '/diet-calculator/result',
          desc: '吃得够精准<br/>瘦身才高效',
          count: '无限次数',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9a961d861d56472d279d14d184603ff9.png',
          bgColor: 'linear-gradient(133deg, #F2F5FF 0%, #E1E9FD 100%)'
        }
      ]
    }
  },
  computed: {
    myShowRight() {
      let data = deepClone(this.myRight)
      console.log(data)
      data.map((item) => {
        item.list = item.list.filter((item1) => {
          return item1.hide == false
        })
      })
      data = data.filter((item) => {
        return item.list && item.list.length
      })
      return data
    },
    myShowRightList() {
      let data = deepClone(this.myRight)
      let res = []
      data.map((item, index) => {
        item.list.map((item1, index1) => {
          if (item1.hide == false) {
            res.push(item1)
          }
        })
      })
      return res
    }
  },
  watch: {
    vipInfo: {
      immediate: true,
      handler() {
        this.myRight = getRightList(this.vipInfo.type_id)
      }
    }
  },
  created() {
    this.init()
  },
  activated() {
    this.init()
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    bindClickBanner(item) {
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      }
    },
    init() {
      console.log('初始化')
      this.getBannerList()
      this.getCampList()
      this.getCouponData()
      this.getCampCoupon()
      this.getDietPlan()
      this.getMenuAvailableNum()
    },
    bindReceiveCourse(index) {
      let courseList = [
        {
          title: '会员专属8大减脂营养课程',
          url: 'https://kgfxu.xet.tech/s/2H3oz1'
        },
        {
          title: '会员专属8大减脂运动课程',
          url: 'https://kgfxu.xet.tech/s/3HstGd'
        }
      ]
      this.$betterwe.onAppPageUrlRoute(
        '/web?url=' + encodeURIComponent(courseList[index].url)
      )
    },
    getBannerList() {
      if (this.vipInfo.type_id == 1) {
        let params = {
          position_type: '21', //位置类型
          resource_type: '1' //资源位类型
        }
        this.$http
          .getAdvData(
            'member/ResourceLocation/getShowResourceLocationNew',
            params
          )
          .then((res) => {
            res = res.data
            if (res.code === 200) {
              this.bannerList = res.data || []
            } else {
              this.$toast(res.msg)
            }
          })
          .catch((err) => {})
      }
    },
    bindExplain() {
      this.$router.push('/betterwe/vip-explain')
    },
    bindClose() {
      this.showToast = false
    },
    bindShowToast(item) {
      this.toastData = item
      this.showToast = true
    },
    //获取可使用次数
    getMenuAvailableNum() {
      this.$http
        .postApp('api/v1/WeEquity/getAvailableNum', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.menuList.map((item) => {
              if (res.data[item.name].type == 1) {
                item.count = '无限次数'
              } else {
                item.count = res.data[item.name].num + '次/天'
              }
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    bindRightMenu(id) {
      let el = document.getElementById('right-' + id)
      let offsetTop = el.offsetTop - 200
      if (document.documentElement) {
        document.documentElement.scrollTop = offsetTop
      } else if (document.body) {
        document.body.scrollTop = offsetTop
      } else {
        document.scrollTop = offsetTop
      }
    },
    bindNavScroll(e) {
      let a = 15 //总宽度减去黑色区域宽度
      let clientWidth = e.target.clientWidth
      let scrollLeft = e.target.scrollLeft
      let scrollWidth = e.target.scrollWidth
      let percentage = scrollLeft / (scrollWidth - clientWidth)
      this.curLineLeft = percentage.toFixed(2) * a
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset
      if (scrollTop >= 100) {
        this.options = {
          barBackgroundColor: '#fff',
          color: 'rgba(0,0,0.8)'
        }
      } else {
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(0,0,0.8)'
        }
      }
    },
    /* 营养师答疑 */
    bindCoachReply() {
      if (this.$http._isApp()) {
        bindConsultCoach(this.vipInfo.type_id)
      }
      bindConsultCoach(this.vipInfo.type_id)
    },
    //点击工具列表
    bindClickMenu(item) {
      this.$router.push(item.router)
    },
    //点击营养课
    bindClickCourse(item) {
      let url =
        '/miniProgram?userName=gh_2d675ad9b692&path=' +
        encodeURIComponent(item.url)
      this.$betterwe.jumpRoute(url)
    },
    bindClickAllCourse() {
      let url =
        '/miniProgram?userName=gh_2d675ad9b692&path=' +
        encodeURIComponent(courseList[0].url)
      this.$betterwe.jumpRoute(url)
    },
    bindClickAllSport() {
      let url =
        '/miniProgram?userName=gh_2d675ad9b692&path=' +
        encodeURIComponent(sportList[0].url)
      this.$betterwe.jumpRoute(url)
    },
    //减脂营100元抵扣券
    bindToCoupon() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/market/coupon/index&title=商城'
        )
      }
    },
    //去商城
    bindShop() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/0/shop/index?id=13736883&title=商城'
        )
      }
    },
    //领取健萌线下体验课
    bindCourse() {
      if (this.$http._isApp()) {
        bindConsultGym(this.vipInfo.type_id)
      }
    },
    //获取三日营期权益列表
    getCampList() {
      this.$http
        .postApp('api/v1/WeEquity/getAppointmentList', { mc_id: 1 })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.changeRightDataById(2, 'use', res.data.num || 0)
            this.changeRightDataById(
              2,
              'data',
              this.addStartEndTime(res.data.list || [])
            )
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //添加有效期时间
    addStartEndTime(list) {
      list.map((item) => {
        let time =
          '有效期：' +
          this.vipInfo.start_time.slice(0, 10).replace(/-/g, '.') +
          '-' +
          this.vipInfo.end_time.slice(0, 10).replace(/-/g, '.')
        item.startEnedTime = time
      })
      return list
    },
    //获取cna7日营养干预方案使用情况
    getDietPlan() {
      this.$http
        .postApp('api/v1/WeEquity/getCnaList', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.changeRightDataById(1, 'canUse', res.data.issue_total)
            this.changeRightDataById(1, 'use', res.data.num)
            this.changeRightDataById(
              1,
              'data',
              this.dealDietPlan(
                res.data.poster_list || [],
                res.data.issue_total,
                res.data.cna_type
              )
            )
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //处理获得的cna问卷列表数据
    dealDietPlan(data, total, cnaType) {
      data.map((item, index) => {
        item.cnaType = cnaType
        let times = item.que_time && item.que_time.replace(/-/g, '/')
        if (
          times &&
          item.que_time &&
          this.bjTimeToLocal(times).getTime() <= new Date().getTime()
        ) {
          item.success = true
        } else {
          item.success = false
        }
        return item
      })
      data = this.computeList(data, total)
      data.map((item) => {
        if ((item.success && item.plan_flag == 3) || item.cna_state == 3) {
          item.btnText = '查看结果'
        } else if (!item.success && item.plan_flag == 3) {
          item.btnText = '已提交'
        } else if (item.plan_flag == -1) {
          item.btnText = '待使用'
          item.disabled = true
        } else {
          item.btnText = '立即使用'
        }
      })
      return data
    },
    //根据年卡用户cna问卷应获得的问卷数量初始化列表 如果用户已经存在的cna问卷数量不够则添加未使用的
    computeList(list, count) {
      if (list.length < count) {
        let addCount = count - list.length
        for (let i = 0; i < addCount; i++) {
          list.push({
            plan_flag: -1
          })
        }
      }
      return list
    },
    //指定的北京时间信息转成世界各地时间
    bjTimeToLocal(bj_str) {
      let local = new Date(bj_str)
      let bj_zone = 8
      var d = new Date()
      var tmpHours = local.getHours()
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60
      if (time_zone > bj_zone) {
        local.setHours(tmpHours + Math.abs(time_zone - bj_zone))
      } else {
        local.setHours(tmpHours - Math.abs(bj_zone - time_zone))
      }
      return local
    },
    //获取券包数据
    getCouponData() {
      this.$http
        .postApp('api/v1/WeEquity/getCouponBagList', { mc_id: 1 })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = (res.data && res.data.list) || []
            this.changeRightDataById(6, 'data', data)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //获取营期优惠券
    getCampCoupon() {
      this.$http
        .postApp('api/v1/WeEquity/getCourseCouponList', { mc_id: 1 })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = (res.data && res.data.record_list) || []
            this.changeRightDataById(5, 'data', data)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    changeRightDataById(id, str, data) {
      for (let i = 0; i < this.myRight.length; i++) {
        this.myRight[i].list.map((item) => {
          if (item.id == id) {
            //如果后端返回的数据是空的则隐藏对应权限
            if (
              str == 'data' &&
              (!data || (Array.isArray(data) && !data.length))
            ) {
              item.hide = true
              return
            }
            item.hide = false
            item[str] = data
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.vip {
  min-height: 100vh;
  overflow: hidden;
  background-color: #f7f7f7;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/151f957f9cda00244e89054ff663a3c6.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;

  .explain {
    font-size: 24px;
  }

  .user-info {
    position: relative;
    width: 343px;
    height: 170px;
    margin: 32px auto 24px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4eb98e3218a54d0eff320b5fd7dd43e4.png');
    background-repeat: no-repeat;
    background-size: contain;
    overflow: hidden;
    border-radius: 12px;

    .u-top {
      padding: 12px 16px 28px;
      box-sizing: border-box;

      .u-top-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 34px;

        .vip-type {
          text-indent: 36px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #f8d4ba;
          line-height: 14px;
        }

        .end-time {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.3);
          line-height: 14px;

          .time {
            font-size: 14px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: rgba(255, 255, 255, 0.3);
            line-height: 14px;
            margin-left: 4px;
          }
        }
      }

      .info {
        display: flex;
        align-items: center;

        .avatar {
          width: 46px;
          height: 46px;
          box-sizing: border-box;
          border: 2px solid rgba(216, 216, 216, 1);
          border-radius: 50%;
          overflow: hidden;
          object-fit: cover;
          margin-right: 10px;
        }

        .info-r {
          color: #5c3f1f;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;

          .nickname {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #5c3f1f;
            line-height: 16px;
            background: linear-gradient(278deg, #f8d4ba 0%, #eecfba 100%);
            background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 8px;
          }

          .desc {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #5c3f1f;
            line-height: 14px;
            background: linear-gradient(278deg, #f8d4ba 0%, #eecfba 100%);
            background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }

    .u-bottom {
      position: absolute;
      left: 0;
      width: 100%;
      height: 42px;
      bottom: 0;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 14px 16px;

      .iconfont {
        width: 16px;
        height: 16px;
        object-fit: contain;
        margin-right: 4px;
        color: #fff;
      }

      .text1 {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(255, 255, 255, 0.6);
        line-height: 14px;
      }

      .text2 {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(255, 255, 255, 0.6);
        line-height: 14px;
      }
    }
  }

  .my-right {
    width: 343px;
    margin: 0 auto 35px;
    border-radius: 12px;
    overflow: hidden;

    .image-title {
      width: 150px;
      height: 40px;
      object-fit: contain;
      margin: 0 auto 30px;
    }

    .icon-container {
      width: 100%;
      display: inline-block;
      margin-bottom: 24px;

      .icon-scroll {
        overflow-y: scroll;
        margin-bottom: 8px;

        .icon-list {
          display: inline-flex;
          padding: 0px 16px;

          .icon-item {
            margin-right: 20px;

            .icon-image {
              margin: 0 auto 6px;
              width: 36px;
              height: 36px;
              background-color: rgba(248, 212, 186, 1);
              border-radius: 12px;
            }

            .icon-text {
              white-space: nowrap;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #16161c;
              line-height: 16px;
            }
          }

          .icon-item:last-child {
            margin-right: 0;
          }
        }
      }

      .icon-line {
        position: relative;
        margin: 0 auto;
        width: 31px;
        height: 4px;
        background: rgba(81, 83, 96, 0.2);
        border-radius: 2px;

        .line {
          position: absolute;
          left: 0;
          top: 0;
          width: 16px;
          height: 4px;
          background: #515360;
          border-radius: 2px;
        }
      }
    }

    .banner-swipe {
      .banner-image {
        width: 100%;
        height: 80px;
        object-fit: contain;
      }
    }

    .right-list {
      margin-top: 25px;

      .right-ul {
        margin-bottom: 25px;
        background: #ffffff;
        border-radius: 12px;
        padding-bottom: 20px;
      }

      /* 如果给right-ul设置position会导致子元素的offset基于上一个position的元素，导致滚动导航失效 */
      .top-title-position {
        height: 42px;
        position: relative;
      }

      .top-title {
        position: absolute;
        width: 182px;
        height: 32px;
        left: 50%;
        top: -9px;
        object-fit: contain;
        transform: translate(-50%, 0%);
      }

      .right-li {
        .right-item {
          margin-bottom: 24px;

          .r-i-top {
            display: flex;
            align-items: center;
            padding: 0px 14px;
            margin-bottom: 13px;

            .r-i-flag {
              width: 42px;
              height: 18px;
              object-fit: contain;
              margin-right: 4px;
            }

            .r-i-title {
              margin-right: 16px;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 24px;
            }

            .r-receive {
              color: #776fe0;
              font-weight: 600;
            }

            .r-space {
              flex: 1;
              flex-shrink: 0;
            }

            .use-status {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.5);
              line-height: 14px;
            }

            .all {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.5);
              line-height: 14px;

              .iconfont {
                margin-left: 4px;
                font-size: 10px;
              }
            }
          }

          .r-i-bottom {
            .answer-content {
              width: 315px;
              height: 96px;
              box-sizing: border-box;
              padding: 12px 16px 16px;
              box-sizing: border-box;
              margin: 0 auto;
              position: relative;
              background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/27b8f3d3366fed43178f72fa0ba5646b.png');
              background-repeat: no-repeat;
              background-size: contain;
              border-radius: 8px;

              .a-title {
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .title {
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  color: rgba(0, 0, 0, 0.8);
                  line-height: 24px;
                  margin-right: 6px;
                }

                .tip {
                  height: 16px;
                  background: linear-gradient(88deg, #fdc97e 0%, #fdd59d 100%);
                  font-size: 10px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  padding: 0px 4px;
                  color: #96734d;
                  line-height: 16px;
                  border-radius: 4px;
                  position: relative;
                }

                .tip::after {
                  position: absolute;
                  top: 50%;
                  left: -4px;
                  transform: translate(0%, -50%);
                  content: '';
                  width: 0;
                  height: 0;
                  border-right: 4px solid #fdc97e;
                  border-bottom: 3px solid transparent;
                  border-top: 3px solid transparent;
                }
              }

              .desc1 {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 14px;
                margin-bottom: 12px;
              }

              .btn {
                position: absolute;
                top: 33px;
                right: 16px;
                height: 30px;
                line-height: 30px;
                background: linear-gradient(90deg, #f5bb61 0%, #f1ac25 100%);
                border-radius: 15px;
                padding: 0px 6px 0px 10px;
                font-size: 14px;
                font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                font-weight: 600;
                color: #ffffff;
              }
            }

            .tool-scroll {
              overflow-x: scroll;
            }

            .course-tips {
              padding-left: 14px;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 14px;
              margin-top: 12px;
            }

            .tool-list {
              display: inline-flex;
              align-items: center;
              padding: 0px 14px;

              .course-item {
                margin-right: 10px;

                .course-image {
                  width: 130px;
                  height: 118px;
                  object-fit: contain;
                }
              }

              .tool-item {
                position: relative;
                width: 147px;
                height: 112px;
                padding: 10px 16px;
                box-sizing: border-box;
                background: linear-gradient(133deg, #f8faff 0%, #e1e9fd 100%);
                border-radius: 8px;
                margin-right: 10px;

                .i-top {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 4px;

                  .i-title {
                    flex: 1;
                    flex-shrink: 0;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.8);
                    line-height: 24px;
                  }

                  .iconfont {
                    width: 16px;
                    height: 16px;
                    font-weight: 600;
                    background: rgba(255, 255, 255, 0.5);
                    color: rgba(0, 0, 0, 0.6);
                    border-radius: 50%;
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }

                .i-desc {
                  font-size: 11px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  color: rgba(0, 0, 0, 0.6);
                  line-height: 14px;
                  margin-bottom: 9px;
                }

                .count {
                  position: absolute;
                  left: 16px;
                  bottom: 19px;
                  display: inline-block;
                  padding: 0px 6px;
                  line-height: 16px;
                  border-radius: 4px;
                  height: 16px;
                  background: linear-gradient(90deg, #c276fa 0%, #5e7dff 100%);
                  font-size: 10px;
                  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                  font-weight: 600;
                  color: #ffffff;
                }

                .count::after {
                  content: '';
                  position: absolute;
                  top: -3px;
                  left: 50%;
                  transform: translate(-50%, 0%);
                  width: 0;
                  height: 0;
                  border-left: 4px solid transparent;
                  border-right: 4px solid transparent;
                  border-bottom: 4px solid rgb(151, 121, 252);
                }

                .i-image {
                  position: absolute;
                  right: 6px;
                  bottom: 6px;
                  width: 40px;
                  height: 40px;
                  object-fit: contain;
                }
              }

              .tool-item:last-child {
                margin-right: 0;
              }
            }

            .coupon {
              width: 315px;
              height: 96px;
              margin: 0px auto;
              position: relative;
              padding: 12px 20px 20px;
              box-sizing: border-box;

              .c-title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.8);
                line-height: 24px;
                margin-bottom: 5px;
              }

              .c-desc {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 14px;
                margin-bottom: 9px;
              }

              .btn {
                padding: 0px 6px 0px 10px;
                position: absolute;
                display: flex;
                align-items: center;
                right: 16px;
                top: 50%;
                transform: translate(0%, -50%);
                height: 30px;
                background: linear-gradient(90deg, #e2b571 0%, #d09946 100%);
                border-radius: 15px;
                font-size: 14px;
                font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                font-weight: 600;
                color: #ffffff;
                line-height: 30px;
              }

              .btn-disabled {
                background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
              }
            }

            .camp-coupon {
              padding-top: 23px;
              background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/203cbeeba2680c8f67bdf0123aaaca48.png');
              background-repeat: no-repeat;
              background-size: contain;

              .coupon-num {
                font-size: 22px;
                font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                color: #8d5d2e;
                line-height: 28px;
                margin-right: 2px;
              }

              .coupon-name {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #8d5d2e;
                line-height: 24px;
                margin-bottom: 6px;
              }

              .range {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 14px;
              }

              .disabled-btn {
                background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
              }
            }

            .shop-coupon {
              background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/335118d896b6f1a45a60d12ab543f0f9.png');
              background-repeat: no-repeat;
              background-size: contain;

              .btn {
                background: linear-gradient(90deg, #95b5fd 0%, #7091f6 100%);
              }
            }

            .gym-coupon {
              background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3b1198303bd9743f65e170e9d79ee562.png');
              background-repeat: no-repeat;
              background-size: contain;

              .tip {
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.6);
                line-height: 16px;
              }

              .btn {
                background: linear-gradient(93deg, #f4b3bd 0%, #f77aa4 100%);
              }
            }
          }
        }

        .right-item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
